import { CmsRegistrationRoot } from '../cms/cms-registration-root.interface';
import { CmsRegistrationOrderConfirmationPageHeader } from './cms-registration-order-confirmation-page-header.interface';
import { CmsRegistrationOrderConfirmationPlanDetailsPanel } from './cms-registration-order-confirmation-page-plan-details-panel.interface';

export type CmsRegistrationOrderConfirmationPage = CmsRegistrationRoot &
  CmsRegistrationOrderConfirmationPageHeader &
  CmsRegistrationOrderConfirmationPlanDetailsPanel;
